import createActionType from "../../utils/createActionType";

export const MODULE = "delivery-scheduling/orders";

export const SET_IS_FETCHING_ORDERS = createActionType(MODULE, "setIsFetchingOrders");

export const SET_ORDERS = createActionType(MODULE, "setOrders");

export const RESET = createActionType(MODULE, "reset");
